import type { FC } from 'react'
import { useUserSession } from 'hooks'
import { Menu, Link } from 'components/ui'
import { ROUTE_USER_ACCOUNT, ROUTE_USER_LOGOUT, ROUTE_USER_SIGN_IN } from 'routes/user'
import type { UserSessionButtonProps } from './types'
import s from './user-session-button.module.css'

const DROPDOWN = [
  {
    href: ROUTE_USER_ACCOUNT,
    label: 'Minha Conta',
  },
  {
    href: ROUTE_USER_LOGOUT,
    value: 'LOGOUT',
    label: 'Sair',
  },
]

const UserSessionButton: FC<UserSessionButtonProps> = () => {
  const { user } = useUserSession()

  const userName = () => {
    if (user?.name) {
      const username = user.name.split(' ')
      const firstName = username[0]
      return firstName
    }
    return 'Cliente'
  }
  const userId = user?.id

  if (userId) {
    return <Menu label={userName()} items={DROPDOWN} />
  }

  return (
    <Link href={ROUTE_USER_SIGN_IN} className={s.link}>
      Entrar
    </Link>
  )
}

export default UserSessionButton
